import {
    GetInvitesQuery,
    GetInvitesQueryVariables
} from 'generated/graphql'
import { getNodes } from 'graphql/utils'
import { usePagination } from '../pagination'
import { invitesQuery } from './graphql/query'

const getList = (data: GetInvitesQuery) => getNodes(data?.event?.invites)
const getPageInfo = (data: GetInvitesQuery) => data?.event?.invites?.pageInfo
const getTotalCount = (data: GetInvitesQuery) => data?.event?.invites?.totalCount

export const useInvites = (
    { ...variables }: GetInvitesQueryVariables
) => usePagination<GetInvitesQuery, GetInvitesQueryVariables>({
    query: invitesQuery,
    initPage: 1,
    initItemsPerPage: 50,
    getList,
    getPageInfo,
    getTotalCount,
    variables,
})
